export const environment = {
  production: true,
  buildId: '3202958408520911',
  configFile: 'config.json',
};
